import React from 'react';
import './OrgPickerDialog.css';

/**
 * Shown at login when user has access to multiple organizations.
 * On select: persist org id and redirect to org dashboard.
 */
const OrgPickerDialog = ({ organizations, onSelect }) => {
  return (
    <div className="dialog-overlay org-picker-overlay">
      <div className="dialog-content org-picker-content">
        <h2>Choose organization</h2>
        <p className="dialog-question">
          You have access to more than one organization. Select which one to open.
        </p>
        <div className="org-picker-list">
          {organizations.map((org) => (
            <button
              key={org.id}
              type="button"
              className="org-picker-item"
              onClick={() => onSelect(org.id)}
            >
              <span className="org-picker-name">{org.name}</span>
              <span className="org-picker-meta">
                {org.orgType === 'on_campus_org' ? 'On-Campus Org' : 'University/College'}
                {org.domain && org.id !== org.domain && (
                  <> · {org.domain}</>
                )}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrgPickerDialog;
